
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-martin",
      function () {
        return require("private-next-pages/about-martin/index.js");
      }
    ]);
  